module.exports = __webpack_public_path__ + "static/media/logo_TechComBank.66ba2a58.svg";